import "../../../../assets/presentation/components/controls/text-input/text-input-icon-MVuIjesj.css";
/* empty css                */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-icon.tsx
var TextInputIcon = ({ className, children, testId }) => /* @__PURE__ */ jsx("span", {
	className: classNames("text-input-icon", className),
	"data-testid": testId,
	children
});
//#endregion
export { TextInputIcon };

//# sourceMappingURL=text-input-icon2.js.map